import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { useHistory } from "react-router-dom";
import { useFilter } from "@sajari/react-hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { memo } from "react";

const FilterRender = memo(({ name, value }: any) => {
  const history = useHistory();
  const { setSelected } = useFilter(name);
  return (
    <Link
      underline="hover"
      color="inherit"
      onClick={() => {
        history.goBack();
        setTimeout(() => setSelected([value]), 1500);
      }}
      style={{ cursor: "pointer" }}
    >
      <Typography color="text.primary">{value}</Typography>
    </Link>
  );
});

export default function BasicBreadcrumbs(props: any) {
  const history = useHistory();
  const BrandFilterLink = () => (
    <FilterRender name="brand" value={props.brand} />
  );
  const CategoryFilterLink = () => (
    <FilterRender name="category" value={props.category} />
  );

  return (
    <div role="presentation">
      {props.isProductPage ? (
        <Breadcrumbs aria-label="breadcrumb" separator="›">
          {/* <Link
            underline="hover"
            color="inherit"
            onClick={() => history.goBack()}
            style={{ cursor: "pointer" }}
          >
            <Typography
              color="text.primary"
              sx={{ textDecoration: "underline" }}
            >
              <FontAwesomeIcon
                icon={faArrowLeft}
                style={{ marginRight: "0.5em" }}
              />
              Back to search results
            </Typography>
          </Link> */}
          <Link
            underline="hover"
            color="inherit"
            onClick={() => history.push("/")}
            style={{ cursor: "pointer" }}
          >
            <Typography color="text.primary">Home</Typography>
          </Link>
          <CategoryFilterLink />
          <BrandFilterLink />
        </Breadcrumbs>
      ) : (
        <Breadcrumbs aria-label="breadcrumb" separator="›">
          <Link
            underline="hover"
            color="inherit"
            href="/"
            onClick={() => history.push("/")}
          >
            <Typography color="text.primary">Home</Typography>
          </Link>
          <Link underline="hover" color="inherit">
            {props.query}
          </Link>
        </Breadcrumbs>
      )}
    </div>
  );
}
